import React, { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface ScrollableSectionProps {
  title: string;
  children: ReactNode;
  viewAllLink?: string;
  viewAllText?: string;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

const ScrollableSection: React.FC<ScrollableSectionProps> = ({
  title,
  children,
  viewAllLink,
  viewAllText = 'Xem tất cả',
  className,
  titleClassName,
  contentClassName,
}) => {
  return (
    <section className={cn("my-3", className)}>
      {/* Section Header */}
      <div className="flex items-center justify-between mb-2 px-4">
        <h2 className={cn("text-lg font-bold", titleClassName)}>
          {title}
        </h2>
        
        {viewAllLink && (
          <Link 
            to={viewAllLink} 
            className="flex items-center text-xs text-primary font-medium"
          >
            <span>{viewAllText}</span>
            <ChevronRight className="h-3 w-3 ml-0.5" />
          </Link>
        )}
      </div>
      
      {/* Scrollable Content */}
      <div 
        className={cn(
          "flex overflow-x-auto hide-scrollbar pb-2 px-4",
          "scroll-smooth snap-x snap-mandatory",
          contentClassName
        )}
        style={{scrollPaddingLeft: '16px', scrollPaddingRight: '16px', gap: '10px'}}
      >
        {children}
      </div>
    </section>
  );
};

export default ScrollableSection; 